module.exports = __webpack_public_path__ + "static/media/menu.27e5c8bb.svg";